export default {
	getAuthResller(state){return state.auth; },
	getLoggedInResller(state) { return state.token_r; },
    getSessionTemp(state, val){return state.sessionTemp;},
	lateral(state) { return state.lateralShow; },
	getProfile(state) { return state.profile; },
}
